import { useState, useEffect, useMemo, useCallback } from "react";
import "./App.css";
import * as waxjs from "@waxio/waxjs/dist";
import AnchorLink, { LinkSession } from "anchor-link";
import AnchorLinkBrowserTransport from "anchor-link-browser-transport";
import { ChainWire } from "./components/feactures/dataProvider_Testnet";
import {
  LoadAccountBalance,
  LoadPrices,
  LoadBugTable
} from "./components/feactures/dataFetcher";
import {
  initializeTestnetLogin,
  getTestnetBalance,
  getTestnetWallet
} from "./services/testnetAutoLogin";
import { clearTestnetSession } from "./services/testnetAutoLogin";
import { Route, Routes, useLocation } from "react-router-dom";
import NavBar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import HomeDashboard from "./pages/HomeDashboard";
import { LoginModal } from "./components/Modals";
import {
  Inventory,
  InventorySW,
  ItemsDetails,
  InvBlueprints
} from "./pages/Inventory";
import {
  InventorySpecials,
  InventoryPresaleBoxes,
  InventoryRewardsBoxes,
  BuggedRewardBoxes
} from "./pages/InventorySpecials";
import { EditTeam, Expedition, InterExped } from "./pages/Expeditions";
import { ProfileDashboard } from "./pages/ProfileDashboard";
import {
  Workshops,
  Alchemist,
  Scrapyard,
  BillysWorkshop
} from "./pages/Workshops";
import { CouncilBank } from "./pages/CouncilBank";
import { BlackMarket } from "./pages/BlackMarket";
import { RadiationAlliance } from "./pages/RadiationAlliance";

function App() {
  const [anchorSessions, setAnchorSessions] = useState();

  const [refreshBug, setRefresBug] = useState();
  const [debugData, setDebugData] = useState({
    isBug: false,
    data: []
  });
  const [userData, setUserData] = useState({
    isConnected: false,
    whichProvider: "",
    username: "No Connected",
    auths: [],
    sessionData: {},
    userBalances: {
      bFullWax: "NO WAX BALANCE",
      bShortWax: "NO",
      bFullOnyx: "NO ONYX BALANCE",
      bShortOnyx: "NO",
      bFullNeo: "NO NEO BALANCE",
      bShortNeo: "NO",
      bFullChalce: "NO CHALCE BALANCE",
      bShortChalce: "NO"
    }
  });
  const [pricesFees, setPricesFees] = useState({
    teamfee: "",
    repairfee: "",
    deployfee: "",
    slotfee: "",
    neoreward: "",
    chalreaward: "",
    scrapfee: "",
    craftsuitfee: "",
    craftwepfee: "",
    traintime: "",
    crateSuit: "",
    crateWeapon: "",
    crateDouble: "",
    onSale: ""
  });

  const [errorMessage, setErrorMessage] = useState(null);
  const [toggleSideBar, setToggleSideBar] = useState(false);
  const [tryLoggin, setTryLoggin] = useState(false);

  const [refreshBalance, setRefreshBalance] = useState();
  const [reRender, setRerender] = useState();

  const [showLoader, setShowLoader] = useState(true);

  const endpoint_url = () => {
    const data = window.localStorage.getItem("userEndpoint-extinctionWars");
    if (data !== null) {
      return data;
    } else {
      // return "https://api.waxsweden.org";
      return "https://testnet.wax.pink.gg"; // TESTNET
    }
  };

  const rpcEndpoint = endpoint_url();

  const wax = useMemo(() => {
    return new waxjs.WaxJS({
      rpcEndpoint: rpcEndpoint,
      tryAutoLogin: false
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rpcEndpoint]);

  const link = useMemo(() => {
    const transport = new AnchorLinkBrowserTransport();
    return new AnchorLink({
      transport,
      chains: [
        {
          nodeUrl: rpcEndpoint,
          chainId: ChainWire.chainId
        }
      ]
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rpcEndpoint]);

  const { pathname } = useLocation();

  // Mount: restore sessions (Anchor, Wax Cloud or Testnet)
  useEffect(() => {
    const autoLoginWCW = window.localStorage.getItem(
      "aLoginWcw-extinctionWars"
    );

    // attempt to restore anchor session first, falls back to testnet
    restoreSessionAnchor();
    if (autoLoginWCW) {
      restoreLoginWaxCloud();
    }
    // run once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // callbacks for data operations to keep stable references
  const balanceUser = useCallback(
    (accountName) => {
      if (!accountName) return;

      try {
        if (userData && userData.whichProvider === "Testnet") {
          getTestnetBalance(accountName)
            .then((balances) => {
              setUserData((state) => ({
                ...state,
                userBalances: {
                  bFullWax: balances.wax,
                  bShortWax: (balances.wax || "0.00000000 WAX").split(" ")[0],
                  bFullOnyx: balances.onyx,
                  bShortOnyx: (balances.onyx || "0.0000 ONYX").split(" ")[0],
                  bFullNeo: balances.neo,
                  bShortNeo: (balances.neo || "0.0000 NEO").split(" ")[0],
                  bFullChalce: balances.chalce,
                  bShortChalce: (balances.chalce || "0.0000 CHAL").split(" ")[0]
                }
              }));
            })
            .catch((err) =>
              console.warn("Error loading testnet balances:", err)
            );
        } else {
          LoadAccountBalance(accountName)
            .then((x) => {
              setUserData((state) => ({
                ...state,
                userBalances: x
              }));
            })
            .catch((err) => console.warn("Error loading balances:", err));
        }
      } catch (e) {
        console.error("Unexpected error in balanceUser:", e);
      }
    },
    [userData]
  );

  const loadBugHUD = useCallback(
    async (accountName) => {
      setDebugData({
        isBug: false,
        data: []
      });

      const user = accountName || userData.username;
      LoadBugTable(user).then((x) => {
        if (Number(x.length) !== 0) {
          if (x[0].user === user) {
            setDebugData({
              isBug: true,
              data: x
            });
          }
        } else {
          setDebugData({
            isBug: false,
            data: []
          });
        }
      });
    },
    [userData.username]
  );

  const pricesData = useCallback(async () => {
    LoadPrices().then((x) => {
      setPricesFees(x);
    });
  }, []);

  // Effect: respond to connection state and refresh flags
  useEffect(() => {
    if (userData.isConnected) {
      if (refreshBalance === true) {
        balanceUser(userData.username);
        setRefreshBalance(false);
      }
      if (refreshBug === true) {
        loadBugHUD(userData.username);
        setRefresBug(false);
      }
      pricesData();
      loadBugHUD(userData.username);
      setRerender(false);
    }
  }, [
    userData.isConnected,
    refreshBalance,
    refreshBug,
    balanceUser,
    loadBugHUD,
    pricesData
  ]);
  const closerLoader = () => setShowLoader(false);

  // FUNCION PARA CARGAR AUTOLOGIN WAX CLOUD WALLET * DESACTIVADA DE MOMENTO FALTA MODULO LOGOUT*
  const restoreLoginWaxCloud = async () => {
    const isAutoLoginAvailable = await wax.isAutoLoginAvailable();
    if (isAutoLoginAvailable) {
      try {
        const userName = wax.userAccount;
        const pubkys = wax.pubKeys;
        setUserData((state) => ({
          ...state,
          isConnected: true,
          whichProvider: "WaxCloud",
          username: userName,
          auths: [pubkys],
          sessionData: wax
        }));
        balanceUser(userName);
      } catch (e) {
        setErrorMessage(e.message);
        /// MODAL DE ERROR!
      }
    }
  };

  const restoreSessionAnchor = async () => {
    const lastsession = await link.restoreSession("Extinction Wars App");
    const sessions = await link.listSessions("Extinction Wars App");
    setAnchorSessions(sessions);

    if (lastsession !== null) {
      const userName = lastsession.auth.actor;
      const { auth } = lastsession;
      setUserData((state) => ({
        ...state,
        isConnected: true,
        whichProvider: "Anchor",
        username: userName.toString(),
        auths: auth,
        sessionData: lastsession
      }));

      balanceUser(userName);
    } else {
      // If no Anchor session, try testnet auto-login
      await restoreTestnetSession();
    }
  };

  const restoreTestnetSession = async () => {
    try {
      console.log("🔄 Intentando auto-login testnet...");
      const testnetSession = await initializeTestnetLogin();

      if (testnetSession) {
        const wallet = getTestnetWallet();
        console.log("📱 Wallet testnet obtenida:", wallet.accountName);

        setUserData((state) => ({
          ...state,
          isConnected: true,
          whichProvider: "Testnet",
          username: wallet.accountName,
          auths: [{ actor: wallet.accountName, permission: "active" }],
          sessionData: testnetSession
        }));

        // Load balances from testnet
        const balances = await getTestnetBalance(wallet.accountName);
        console.log("💰 Balances cargados:", balances);

        setUserData((state) => ({
          ...state,
          userBalances: {
            bFullWax: balances.wax,
            bShortWax: balances.wax.split(" ")[0],
            bFullOnyx: balances.onyx,
            bShortOnyx: balances.onyx.split(" ")[0],
            bFullNeo: balances.neo,
            bShortNeo: balances.neo.split(" ")[0],
            bFullChalce: balances.chalce,
            bShortChalce: balances.chalce.split(" ")[0]
          }
        }));

        console.log("✅ Testnet auto-login successful:", wallet.accountName);
      }
    } catch (error) {
      console.error("❌ Testnet auto-login failed:", error.message);
    }
  };
  const loginBlock = (provider) => {
    if (provider === "Anchor") {
      setUserData((state) => ({
        ...state,
        whichProvider: provider
      }));
      SignProvider(provider);
    } else if (provider === "WaxCloud") {
      setUserData((state) => ({
        ...state,
        whichProvider: provider
      }));

      SignProvider(provider);
    }
  };

  const SignProvider = async (provider) => {
    if (provider === "Anchor") {
      try {
        const identify = await link.login("Extinction Wars App");
        const { session } = identify;
        const userName = session.auth.actor;

        setUserData((state) => ({
          ...state,
          isConnected: true,
          username: userName.toString(),
          auths: [session.auth],
          sessionData: session
        }));
        balanceUser(userName);
        trySignIn();
      } catch (e) {
        setErrorMessage(e.message);
        /// MODAL DE ERROR!
      }
    } else if (provider === "WaxCloud") {
      try {
        const userName = await wax.login();
        const pubkys = wax.pubKeys;
        setUserData((state) => ({
          ...state,
          isConnected: true,
          username: userName,
          auths: [pubkys],
          sessionData: wax
        }));
        balanceUser(userName);
        window.localStorage.setItem("aLoginWcw-extinctionWars", true);
        trySignIn();
      } catch (e) {
        setErrorMessage(e.message);
        /// MODAL DE ERROR!
      }
    }
  };

  const disconnect = async (ls = LinkSession) => {
    if (userData.whichProvider === "Anchor") {
      await link.removeSession("Extinction Wars App", ls.auth, ls.chainId);
      if (
        userData.sessionData &&
        userData.sessionData.auth.actor.equals(ls.auth.actor) &&
        userData.sessionData.auth.permission.equals(ls.auth.permission)
      ) {
        setUserData({
          isConnected: false,
          whichProvider: "",
          username: "No Connected",
          auths: [],
          sessionData: {},
          userBalances: {
            bFullWax: "NO WAX BALANCE",
            bShortWax: "NO",
            bFullOnyx: "NO ONYX BALANCE",
            bShortOnyx: "NO",
            bFullNeo: "NO NEO BALANCE",
            bShortNeo: "NO",
            bFullChalce: "NO CHALCE BALANCE",
            bShortChalce: "NO"
          }
        });
      }
      setAnchorSessions(
        anchorSessions.filter(
          (s) =>
            !(
              s.auth.actor.equals(ls.auth.actor) &&
              s.auth.permission.equals(ls.auth.permission)
            )
        )
      );
      setRerender(true);
    } else if (userData.whichProvider === "WaxCloud") {
      window.localStorage.removeItem("aLoginWcw-extinctionWars");
      setUserData({
        isConnected: false,
        whichProvider: "",
        username: "No Connected",
        auths: [],
        sessionData: {},
        userBalances: {
          bFullWax: "NO WAX BALANCE",
          bShortWax: "NO",
          bFullOnyx: "NO ONYX BALANCE",
          bShortOnyx: "NO",
          bFullNeo: "NO NEO BALANCE",
          bShortNeo: "NO",
          bFullChalce: "NO CHALCE BALANCE",
          bShortChalce: "NO"
        }
      });
      setRerender(true);
    } else if (userData.whichProvider === "Testnet") {
      try {
        // Clear stored testnet session and reset UI
        clearTestnetSession();
      } catch (e) {
        console.warn("Error clearing testnet session:", e);
      }
      setUserData({
        isConnected: false,
        whichProvider: "",
        username: "No Connected",
        auths: [],
        sessionData: {},
        userBalances: {
          bFullWax: "NO WAX BALANCE",
          bShortWax: "NO",
          bFullOnyx: "NO ONYX BALANCE",
          bShortOnyx: "NO",
          bFullNeo: "NO NEO BALANCE",
          bShortNeo: "NO",
          bFullChalce: "NO CHALCE BALANCE",
          bShortChalce: "NO"
        }
      });
      setRerender(true);
    }
  };

  const tSideBar = () => {
    setToggleSideBar(!toggleSideBar);
  };

  const trySignIn = () => {
    setTryLoggin(!tryLoggin);
  };

  const rBalance = () => {
    balanceUser(userData.username);
  };

  const rBugsData = () => setDebugData(true);

  if (pathname === "/RA") {
    return (
      <div className="main m-0 p-0">
        <NavBar
          onLogin={() => trySignIn()}
          onLogout={disconnect}
          userData={userData}
          locationUI="RA"
        />
        <div className="main-dashboard">
          <div className="activity-box_BM">
            {tryLoggin && (
              <LoginModal
                closeLogin={() => trySignIn()}
                loginProvider={loginBlock}
              />
            )}
            <Routes>
              <Route
                path="/RA"
                element={
                  <RadiationAlliance
                    userData={userData}
                    showLoader={showLoader}
                    closerLoader={() => closerLoader()}
                    onRefreshBalances={() => rBalance()}
                    pricesFees={pricesFees}
                  />
                }
              />
            </Routes>
          </div>
        </div>
      </div>
    );
  }

  if (pathname === "/BM") {
    return (
      <div className="main m-0 p-0">
        <NavBar
          onLogin={() => trySignIn()}
          onLogout={disconnect}
          userData={userData}
          locationUI="BM"
        />
        <div className="main-dashboard">
          <div className="activity-box_BM">
            {tryLoggin && (
              <LoginModal
                closeLogin={() => trySignIn()}
                loginProvider={loginBlock}
              />
            )}
            <Routes>
              <Route
                path="/BM"
                element={
                  <BlackMarket
                    userData={userData}
                    showLoader={showLoader}
                    closerLoader={() => closerLoader()}
                    onRefreshBalances={() => rBalance()}
                    pricesFees={pricesFees}
                  />
                }
              />
            </Routes>
          </div>
          <div className="sidebar-container"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="main m-0 p-0">
      <NavBar
        onLogin={() => trySignIn()}
        onLogout={disconnect}
        userData={userData}
      />
      <div className="main-dashboard">
        <div className="activity-box">
          {tryLoggin && (
            <LoginModal
              closeLogin={() => trySignIn()}
              loginProvider={loginBlock}
            />
          )}
          <Routes>
            <Route
              path="/"
              element={
                <HomeDashboard
                  userData={userData}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                  onRefreshBalances={() => rBalance()}
                />
              }
            />
            <Route
              path="/ref=:id"
              element={
                <HomeDashboard
                  userData={userData}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                  onRefreshBalances={() => rBalance()}
                />
              }
            />
            <Route
              path="bank"
              element={
                <CouncilBank
                  userData={userData}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                  onRefreshBalances={() => rBalance()}
                  pricesFees={pricesFees}
                />
              }
            />
            <Route
              path="profile"
              element={
                <ProfileDashboard
                  userData={userData}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                  onRefreshBalances={() => rBalance()}
                />
              }
            />
            <Route
              path="inventory"
              element={
                <Inventory
                  userConnected={userData.isConnected}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                />
              }
            />
            <Route
              path="inventory/suits"
              element={
                <InventorySW
                  userData={userData}
                  itemType={"suits"}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                />
              }
            />
            <Route
              path="inventory/suits/:id"
              element={
                <ItemsDetails
                  userData={userData}
                  pricesFees={pricesFees}
                  onRefreshBalances={() => rBalance()}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                />
              }
            />
            <Route
              path="inventory/weapons/:id"
              element={
                <ItemsDetails
                  userData={userData}
                  pricesFees={pricesFees}
                  onRefreshBalances={() => rBalance()}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                />
              }
            />
            <Route
              path="inventory/weapons"
              element={
                <InventorySW
                  userData={userData}
                  itemType={"weapons"}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                />
              }
            />
            <Route
              path="inventory/special-items"
              element={
                <InventorySpecials
                  userData={userData}
                  debugData={debugData}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                />
              }
            />
            <Route
              path="inventory/special-items/presaleboxes"
              element={
                <InventoryPresaleBoxes
                  userData={userData}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                />
              }
            />
            <Route
              path="inventory/special-items/rewardboxes"
              element={
                <InventoryRewardsBoxes
                  userData={userData}
                  pricesFees={pricesFees}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                />
              }
            />
            <Route
              path="inventory/special-items/bugrewardboxes"
              element={
                <BuggedRewardBoxes
                  userData={userData}
                  pricesFees={pricesFees}
                  debugData={debugData}
                  refresh={rBugsData}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                />
              }
            />
            <Route
              path="inventory/bperks"
              element={
                <InvBlueprints
                  userData={userData}
                  itemType={"blueprints"}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                />
              }
            />
            <Route
              path="workshops"
              element={
                <Workshops
                  userData={userData}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                />
              }
            />
            <Route
              path="/workshops/alchemist"
              element={
                <Alchemist
                  userData={userData}
                  onRefreshBalances={() => rBalance()}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                />
              }
            />
            <Route
              path="/workshops/scrapyard"
              element={
                <Scrapyard
                  userData={userData}
                  onRefreshBalances={() => rBalance()}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                  pricesFees={pricesFees}
                />
              }
            />
            <Route
              path="/workshops/billysworkshop"
              element={
                <BillysWorkshop
                  userData={userData}
                  onRefreshBalances={() => rBalance()}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                  pricesFees={pricesFees}
                />
              }
            />
            <Route
              path="expeditions/:location"
              element={
                <Expedition
                  userData={userData}
                  pricesFees={pricesFees}
                  onRefreshBalances={() => rBalance()}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                />
              }
            />
            <Route
              path="expeditions"
              element={
                <InterExped
                  userData={userData}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                />
              }
            />
            <Route
              path="expeditions/:location/editteam/:id"
              element={
                <EditTeam
                  userData={userData}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                  pricesFees={pricesFees}
                  onRefreshBalances={() => rBalance()}
                />
              }
            />
            <Route
              path="/BM/"
              element={
                <HomeDashboard
                  userData={userData}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                  onRefreshBalances={() => rBalance()}
                />
              }
            />
            <Route
              path="/FAQ/"
              element={
                <HomeDashboard
                  userData={userData}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                  onRefreshBalances={() => rBalance()}
                />
              }
            />
            <Route
              path="/Support/"
              element={
                <HomeDashboard
                  userData={userData}
                  showLoader={showLoader}
                  closerLoader={() => closerLoader()}
                  onRefreshBalances={() => rBalance()}
                />
              }
            />
          </Routes>
        </div>
        <div className="sidebar-container">
          <Sidebar toggleInfo={toggleSideBar} onToggle={() => tSideBar()} />
        </div>
      </div>
    </div>
  );
}

export default App;
